module.exports = __webpack_public_path__ + "static/17-70b14d24cd8a43921c8320f37cf0f364.gif";